export default {
  functionKey: "ASSIGNER",
  title: "ASSIGNER",
  group: "Texte",
  target: [],
  targetRequired: true,
  arguments: [],
  maxArguments: 1,
  expectedArguments: [
    { name: "Valeur", argumentKey: "Value", single: true, initialValue: "", empty: true }
  ],
  description: "Assigne une valeur à une destination",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${args[0]};`;
    return { displayCode: code, safeCode: code };
  }
}
